"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ScimResourceLog () {
        return ScimResourceLog;
    },
    get ScimResourceLogActionType () {
        return ScimResourceLogActionType;
    },
    get ScimResourceLogStatus () {
        return ScimResourceLogStatus;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _baseresourcelog = require("../base-resource-log");
const ScimResourceLogActionType = _zod.z.union([
    _zod.z.literal("create"),
    _zod.z.literal("update"),
    _zod.z.literal("deactivate"),
    _zod.z.literal("delete"),
    _zod.z.literal("unknown")
]);
const ScimResourceLogStatus = _zod.z.union([
    _zod.z.literal("completed"),
    _zod.z.literal("failed")
]);
const ScimResourceLog = _baseresourcelog.BaseResourceLog.extend({
    /** resource_id is optional to account for failed sync attempts where there was no resource created */ resource_id: _zod.z.instanceof(_bson.ObjectId).nullable(),
    resource_type: _zod.z.literal("user"),
    change_type: _zod.z.literal("scim"),
    data: _zod.z.object({
        /** scim_token is the _id of the scim_token document that's used in authorization */ scim_token: _zod.z.instanceof(_bson.ObjectId),
        /** user_email is the email of the user that the resource is related to */ user_email: _zod.z.string(),
        /** im_id is optional to account for failed sync attempts where there was no resource created */ im_id: _zod.z.instanceof(_bson.ObjectId).nullable(),
        /** type is the type of action that was performed on the resource */ type: ScimResourceLogActionType,
        /** status is the status of the action (whether is completed or failed) */ status: ScimResourceLogStatus,
        /** will only contain a value when status is failed */ error_message: _zod.z.string().nullable(),
        /** will only contain a value when status is completed */ modified_fields_and_values: _zod.z.array(_zod.z.object({
            field_id: _zod.z.instanceof(_bson.ObjectId),
            value: _zod.z.any()
        })).nullable()
    })
});
